import useCurrentGame from "../../../hooks/useCurrentGame";
import Game from "../../../store/Game";
import ROUTES from "../../../utils/routes";
import INTOUCH_API from "../../../services/Api";
import {
  ADULT_ALERT_WAS_SHOWN,
  CURRENT_GAME_KEY,
  TEMPORARY_ID_KEY,
  CURRENT_TEMP_DEMO_GENDER,
} from "../../../utils/constants";
import useBrowserStorage from "../../../hooks/useBrowserStorage";
import { v4 as uuidv4 } from "uuid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import PersonalAccount from "../../../store/PersonalAccount";
import useCurrentUserData from "../../../hooks/useCurrentUserData";
import useModalActions from "../../../hooks/useModalActions";
import { MODAL_TYPES } from "../../../utils/emitter";
import useCookie from "../../../hooks/useCookie";

export default function useController() {
  const { setGame } = useCurrentGame();
  const { getUserData } = useCurrentUserData();
  const navigate = useNavigate();
  const { getItem, setItem, removeItem } = useBrowserStorage();
  const { setCookie } = useCookie();
  const [isDemoGameLoading, setIsDemoGameLoading] = useState(false);
  const { token } = useAuth();

  const { openModal } = useModalActions();

  // productType — какой тариф выбран в лендинг-блоке (REPEAT_TEST/EXTENDED_57/GAME).
  // Пробрасываем через регистрацию/оплату, иначе все кнопки покупали бы полную игру.
  const buyGame = (productType = "GAME") => {
    if (!token) {
      const inTwoMinutes = new Date(new Date().getTime() + 2 * 60 * 1000);
      setCookie("isWatchFirstTimeGameModal", 1, {
        sameSite: "strict",
        expires: inTwoMinutes,
        secure: true,
      });
      navigate(ROUTES.REGISTER_PAGE, {
        state: { buttonType: "buyGame", productType },
      });
      return;
    }
    navigate(ROUTES.PAYMENT_PAGE, { state: { productType } });
  };

  const startDemoGame = async () => {
    if (isDemoGameLoading) return;
    const demoForm = {
      type: "DEMO",
    };
    const wasShown = getItem(ADULT_ALERT_WAS_SHOWN);
    if (!wasShown) {
      openModal(MODAL_TYPES.ADULT_ALERT);
    }
    if (token) {
      setIsDemoGameLoading(true);
      const userData = getUserData();
      demoForm.userId = userData.id;
      await PersonalAccount.getPersonalAccountData();
      const isManyDemoGames = PersonalAccount.games.length > 1;
      if (isManyDemoGames) {
        navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
      } else if (PersonalAccount.games.length === 1) {
        const game = PersonalAccount.games[0];
        if (game.type === "DEMO") {
          Game.setGame(game);
          setGame(game);
          if (
            !PersonalAccount.user.gameIdsByMeets.some((id) => id === game.id)
          ) {
            navigate(ROUTES.MEET_PAGE, { state: { from: "landing" } });
          } else {
            navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
          }
        } else {
          navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
        }
      }
    } else {
      removeItem(CURRENT_TEMP_DEMO_GENDER);
      let temporaryUserId = "";
      const savedTemporaryUserId = getItem(TEMPORARY_ID_KEY);
      if (savedTemporaryUserId) {
        temporaryUserId = savedTemporaryUserId;

        await INTOUCH_API.requestManager(
          "temporary_current_user",
          { temporaryUserId },
          (response) => {
            Game.getCards("questions_cards_demo", true, null);
            Game.setGame(response.data);
            setGame(response.data);
            navigate(ROUTES.MEET_PAGE, { state: { from: "landing" } });
          },
          () => {},
          () => setIsDemoGameLoading(false)
        );
      } else {
        temporaryUserId = uuidv4();
        setItem("temporaryUserId", temporaryUserId);
        demoForm.temporaryUserId = temporaryUserId;

        await INTOUCH_API.requestManager(
          "createDemoGame",
          demoForm,
          (response) => {
            Game.getCards("questions_cards_demo", true, null);
            Game.setGame(response.data);
            setGame(response.data);
            navigate(ROUTES.MEET_PAGE, { state: { from: "landing" } });
          },
          () => {},
          () => {
            setIsDemoGameLoading(false);
          }
        );
      }
    }
  };

  return {
    startDemoGame,
    isDemoGameLoading,
    buyGame,
  };
}
